module.exports = __webpack_public_path__ + "img/mail.74c4377b.svg";